import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
var common = {
  reset: 'إعادة ضبط',
  cancel: 'يلغي',
  confirm: 'بالتأكيد',
  noData: 'لايوجد بيانات',
  noSearchResult: 'لا توجد نتائج بحث حتى الآن'
};
export default {
  ImageEdit: {
    reset: 'إعادة ضبط',
    cancel: 'يلغي',
    confirm: 'بالتأكيد',
    replace: 'يستبدل',
    imageUpload: 'تحميل الصور',
    picturePreview: 'معاينة الصورة',
    imgClearVisible: ' يرجى التأكد من أن الصورة واضحة للعيان ※',
    imgScale: 'المحاصيل بشكل متناسب',
    zoomIn: 'تكبير',
    zoomOut: 'تصغير',
    rotateLeft: 'استدارة',
    cropSize: 'حجم المحاصيل الحالي'
  },
  Empty: {
    text: common.noData
  },
  LineFold: {
    collapse: 'يغلق',
    expand: 'يوسع'
  },
  OrganizationPicker: _Object$assign(_Object$assign({}, common), {
    prompt: 'تَلمِيح',
    fail: 'فشل الحصول عليها',
    chosen: 'لقد اخترت',
    items: 'غرض',
    click: 'اضغط للعرض',
    org: 'الهيكل التنظيمي',
    chose: 'اختر الهيكل التنظيمي',
    search: 'بحث في الهيكل التنظيمي',
    pleaseChose: 'اختر من فضلك',
    searchContent: 'محتوى البحث',
    loading: 'تحميل',
    chosenItems: 'المحدد',
    empty: 'مسح التحديد',
    city: 'مدينة',
    cityGroup: 'مجموعة المدينة'
  }),
  Evaluation: {
    title: 'هل الميزات المذكورة أعلاه مفيدة لك؟？',
    likeDesc: 'عظيم، شجعني',
    dislikeDesc: 'ليس جيدًا، استمر في التحسين',
    feedbackDesc: 'إعطاء بعض النصائح'
  },
  MultiTableSelector: _Object$assign(_Object$assign({}, common), {
    rightText: 'البيانات المختارة',
    labelText: 'تفضل',
    search: 'استعلام'
  }),
  MultiTabSelector: _Object$assign(_Object$assign({}, common), {
    maxSelected: 'الحد الأقصى للاختيار من بينها',
    ge: 'فردي',
    choose: 'المحدد',
    empty: 'مسح المحدد',
    chooseAll: 'اختر الكل',
    labelText: 'تفضل',
    confirmEmpty: 'موافق للمسح'
  })
};